import { useState } from "react";
import classNames from "classnames";

import { useAuthContext } from "@ascendnow/shared";

import { AscButton, AscPricingCard } from "../../components";
import AscLogo from "../../components/AscLogo/AscLogo";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import {
  DEFAULT_PRICING_PLANS,
  AscPricingPlan,
} from "../../lib/constants/default-pricing-plans";
import { CloseFilledIcon } from "../../components/AscIcons";
import styles from "./AscSubscriptionPaywallView.module.scss";
import { useAscContext } from "../../context";

export interface AscSubscriptionPaywallViewProps {
  className?: string;
  pricingPlans?: typeof DEFAULT_PRICING_PLANS;
  onPricingPlanSelect: (planId: string, priceId?: string) => void;
}

export default function AscSubscriptionPaywallView({
  className,
  pricingPlans = DEFAULT_PRICING_PLANS,
  onPricingPlanSelect,
}: AscSubscriptionPaywallViewProps) {
  const { logout } = useAuthContext();
  const { toast } = useAscContext();
  const [selectedPlan, setSelectedPlan] = useState<AscPricingPlan | null>(
    pricingPlans[1]
  );

  return (
    <main
      data-testid="asc-subscription-paywall-view"
      className={classNames(styles.ground, className)}
    >
      <CloseFilledIcon className={styles.goBack} onClick={() => logout()} />
      <AscLogo href={null} className={styles.logo} />
      <header className={styles.heading}>
        <AscHeading className={styles.title} level={1}>
          The best place to master key skills and find your edge
        </AscHeading>
        <AscParagraph className={styles.subTitle}>
          The plan you choose shows how committed you are to working on
          yourself.
        </AscParagraph>
      </header>
      <div className={styles.pricingPlans}>
        {pricingPlans &&
          Array.isArray(pricingPlans) &&
          pricingPlans.map((plan) => (
            <AscPricingCard
              key={plan?.id}
              type={plan?.name}
              title={plan?.name}
              price={plan?.price.monthly}
              percentSaved={plan?.metadata.save}
              planDurationType={plan?.planDurationType}
              description={plan?.description}
              features={plan?.features}
              isActive={plan?.id === selectedPlan?.id}
              onGetStarted={() => onPricingPlanSelect(plan?.id, plan.priceId)}
              onSelect={() => setSelectedPlan(plan)}
            />
          ))}
      </div>

      <footer className={styles.footer}>
        <AscButton
          size="large"
          fullWidth
          onClick={() => {
            if (selectedPlan) {
              onPricingPlanSelect(selectedPlan?.id, selectedPlan.priceId);
            } else {
              toast.info("Please, select a plan");
            }
          }}
        >
          Contine
        </AscButton>
      </footer>
    </main>
  );
}
